export default "__VITE_ASSET__PkbwooWx__"